import type { DriverStatus, DriverStatusInstruction } from './types';

export class DriverStatusHandler {
  private _status: DriverStatus = 'connected';

  get status(): DriverStatus {
    return this._status;
  }

  onDriverDisconnected(): DriverStatusInstruction {
    this._status = 'disconnected';
    return { type: 'continue_local_playback' };
  }

  onDriverReconnected(): DriverStatusInstruction {
    if (this._status === 'disconnected') {
      this._status = 'reconnected';
      return { type: 'resync' };
    }
    return { type: 'none' };
  }

  onHeartbeatReceived(): void {
    if (this._status === 'reconnected') {
      this._status = 'connected';
    }
  }

  reset(): void {
    this._status = 'connected';
  }
}
